import { FormField, NumberInput } from '@wix/design-system';
import React from 'react';

import type { LogBiFn } from './../../_shared/bi-context-provider/bi-context-provider';

interface TableSettingsCountSectionProps {
  title: string;
  onCountChange: (count: number) => void;
  input: number;
  dataHook: string;
  hasError?: boolean;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  icon: React.ReactNode;
  onBlur: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  logBi: LogBiFn;
}

const TableSettingsCountSection: React.FC<TableSettingsCountSectionProps> = ({
  onCountChange,
  dataHook,
  inputRef,
  input,
  title,
  hasError,
  icon,
  onBlur,
  onKeyDown,
  logBi,
}) => {
  const onChange = (count: number) => {
    onCountChange(count);
    logBi({ dataHook, value: count });
  };

  return (
    <FormField label={title} status={hasError ? 'error' : undefined} suffix={icon}>
      <NumberInput
        inputRef={inputRef}
        value={input}
        onChange={onChange}
        min={0}
        size="small"
        dataHook={dataHook}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
    </FormField>
  );
};

export default TableSettingsCountSection;
